import React, { useState } from 'react';
import { TreeView, TreeItem } from '@material-ui/lab';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import NodeComponent from './target.node.component';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Typography } from '@material-ui/core';
import TableChartIcon from '@material-ui/icons/TableChart';

const useStyles = makeStyles({
  treeItem: {
    '&.Mui-selected > .MuiTreeItem-content .MuiTreeItem-label': {
      backgroundColor: 'transparent',
    },
  },
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
  },
});

const TreeStructure = ({ data, groupTypes, months, selectedYear }) => {
  const classes = useStyles();
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [selectedNode, setSelectedNode] = useState(null);
  const [visibleTableNodeId, setVisibleTableNodeId] = useState(null);

  const handleNodeToggle = (event, nodeIds) => {
    setExpandedNodes(nodeIds);
  };

  const handleNodeSelect = (event, nodeId) => {
    event.preventDefault();
    setSelectedNode(nodeId === selectedNode ? null : nodeId);
  };

  const toggleTableVisibility = (event, nodeId) => {
    event.preventDefault();
    if (!!nodeId && !expandedNodes.some(id => id === nodeId)) {
      setExpandedNodes(prv => [...prv, nodeId]);
    }
    setVisibleTableNodeId(prevNodeId => (prevNodeId === nodeId ? null : nodeId));
  };

  const renderTree = nodes =>
    nodes.map(node => (
      <TreeItem
        key={node.id}
        nodeId={node.id}
        label={
          <div className={classes.labelRoot}>
            <Typography variant="h6">{node.name}</Typography>
            <IconButton
              color={node.id === visibleTableNodeId ? 'inherit' : ''}
              onClick={event => toggleTableVisibility(event, node.id)}>
              <TableChartIcon />
            </IconButton>
          </div>
        }
        className={classes.treeItem}>
        {visibleTableNodeId === node.id && (
          <NodeComponent node={node} groupTypes={groupTypes} selectedYear={selectedYear} months={months} />
        )}
        {Array.isArray(node.positionDTOs) ? renderTree(node.positionDTOs) : null}
      </TreeItem>
    ));

  return (
    <TreeView
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      expanded={expandedNodes}
      onNodeToggle={handleNodeToggle}>
      {renderTree(data)}
    </TreeView>
  );
};

export default TreeStructure;
